import { render, staticRenderFns } from "./addEvnModel.vue?vue&type=template&id=520991f7&scoped=true"
import script from "./addEvnModel.vue?vue&type=script&lang=js"
export * from "./addEvnModel.vue?vue&type=script&lang=js"
import style0 from "./addEvnModel.vue?vue&type=style&index=0&id=520991f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520991f7",
  null
  
)

export default component.exports